// api/imagesClient.js
import axios from 'axios';
import TokenService from '../services/token.service';

/**
 * Cliente HTTP para el Image Service.
 *
 * OJO: el image_service es un microservicio Lambda INDEPENDIENTE, con su propio
 * API Gateway REST (host distinto al del assistant/chat). El invoke URL ya
 * termina en el stage `/v1`, así que el path final es:
 *   {REACT_APP_IMAGES_API_URL}/accounts/{accountId}/images
 *
 * Auth: el gateway tiene authorization = "NONE" y la validación de JWT/API-key
 * corre dentro del Lambda, igual que el assistant service. Por eso reutilizamos
 * el mismo Bearer token de Cognito.
 */
const imagesClient = axios.create({
  baseURL: process.env.REACT_APP_IMAGES_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Interceptor para agregar JWT token automáticamente
 */
imagesClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Interceptor para manejar errores de respuesta
 */
imagesClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('❌ Token inválido o expirado (image service)');
      TokenService.clearTokens();
      window.location.href = '/login';
    }

    if (error.response) {
      console.error('Image API Error:', {
        status: error.response.status,
        data: error.response.data,
        endpoint: error.config?.url,
      });
    } else if (error.request) {
      console.error('No response from image service:', error.request);
    } else {
      console.error('Image request setup error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default imagesClient;
